import DateTimeUtil from "@/util/DateTimeUtil";

export default class BaseUser {

    createUid = 0 ;
    updateUid = 0 ;

    createTime = '' ;
    updateTime = '' ;

    createUserName = '';
    updateUserName = '' ;

}